import React from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import { Button, FormCheck } from 'react-bootstrap'
import { i18nTranslate, IS_BROWSER } from 'src/utils'
import { productDeps } from 'src/deps'
import { promotionContainer } from 'src/models'
import './styles.scss'

@observer
class SubscriptionMultiVariants extends React.Component {
  @observable transformedData = {}
  @observable isPromotionAPIInprogress = false

  constructor(props) {
    super(props)
  }
  componentDidMount() {
    this.transformMultiVariantsData()
    this.props.updateSelectedVariant &&
      this.props.updateSelectedVariant(this.transformedData)
    this.props.actionType === 'edit' && this.makePromotionAPI() //Make promotion API on load of edit modal
  }

  makePromotionAPI = () => {
    const {
      productData = {},
      productPromoDetails = {
        isSubscriptionIncludedInPromotion: true,
        isSubscriptionPromotion: true,
      },
      isBundle = false,
    } = this.props

    let promoDetails = {}
    let bundleData = {}
    this.isPromotionAPIInprogress = true
    if (productData?.isBundle || isBundle) {
      productData.bundleMandatoryProducts =
        this.transformedData.bundleMandatoryProducts || []
      productData.bundleOptionalProducts =
        this.transformedData.bundleOptionalProducts || []

      bundleData = this.getBundleDataOnSkus(productData)
      if (bundleData) {
        promoDetails = {
          productId: productData?.productId || productData.identifier,
          categoryId: productData?.categoryId || '',
          quantity: productData?.productQuantity,
          ...productPromoDetails,
          ...bundleData,
          type: 'bundle',
        }
      }
    } else {
      promoDetails = {
        skuId: this.getNormalSkuSelectedInfo().skuId,
        productId: productData?.productId || productData.identifier,
        categoryId: productData?.categoryId || '',
        type: productData?.type || '',
        ...productPromoDetails,
      }
    }

    promotionContainer.makeSubscriptionPromoAPI(promoDetails)
    this.isPromotionAPIInprogress = false
  }

  getBundleDataOnSkus = (productData = {}) => {
    const bundleData = []
    const mandatoryProduct = productData?.bundleMandatoryProducts || []
    const optionalProduct = productData?.bundleOptionalProducts || []
    mandatoryProduct?.forEach(data => {
      if (data.sku?.length > 1) {
        const selectedSku =
          data.sku.find(skuElement => skuElement.isSelectedForEdit) ||
          data.selectedSku
        bundleData.push({
          skuId: selectedSku.identifier,
          productId: data.identifier,
          skuQuantity: data.properties?.quantity,
          type: 'bundle',
        })
      } else if (data.sku?.length === 1) {
        bundleData.push({
          skuId: data.sku?.[0].identifier,
          productId: data.identifier,
          skuQuantity: data.properties?.quantity,
          type: 'bundle',
        })
      }
    })

    optionalProduct?.forEach(data => {
      if (data.optionalProductAdded) {
        if (data.sku?.length > 1) {
          const selectedSku =
            data.sku.find(skuElement => skuElement.isOptionalSkuSelected) ||
            data.selectedSku
          bundleData.push({
            skuId: selectedSku.identifier,
            productId: data.identifier,
            optionalSkuQuantity: data.properties?.quantity,
            type: 'bundle',
          })
        } else if (data.sku?.length === 1) {
          bundleData.push({
            skuId: data.sku?.[0].identifier,
            productId: data.identifier,
            optionalSkuQuantity: data.properties?.quantity,
            type: 'bundle',
          })
        }
      }
    })

    return { skus: bundleData }
  }
  componentWillUnmount() {
    this.transformedData = {}
  }

  transformMultiVariantsData = () => {
    const {
      isBundle = false,
      sku = [],
      bundleMandatoryProducts = [],
      bundleOptionalProducts = [],
      identifier = '',
      productId = '',
      properties = {},
    } = this.props.productData || {}

    // For normal products, use selectedSkuId from props (from quick search) or fallback to defaultSkuId
    const selectedSkuId = this.props.selectedSkuId || properties?.defaultSkuId || ''
    const skuWithIsSelected =
      this.props.actionType === 'add'
        ? sku.map(item => ({
            ...item,
            isSelected: selectedSkuId
              ? item.identifier === selectedSkuId
              : !!item.default,
          }))
        : sku

    // For bundle products, set selectedSku based on defaultSkuId
    const transformedMandatoryProducts = bundleMandatoryProducts?.map(
      product => {
        const productDefaultSkuId = product?.properties?.defaultSkuId || ''

        const selectedSku =
          product.sku?.find(sku => sku.identifier === productDefaultSkuId) ||
          product.sku?.find(sku => sku.default) ||
          product.sku?.[0]

        return {
          ...product,
          selectedSku,
        }
      }
    )

    const transformedOptionalProducts = bundleOptionalProducts?.map(product => {
      const productDefaultSkuId = product?.properties?.defaultSkuId || ''
      let selectedSku = null

      if (productDefaultSkuId) {
        selectedSku = product.sku?.find(
          sku => sku.identifier === productDefaultSkuId
        )
      }

      if (!selectedSku) {
        selectedSku = product.sku?.find(sku => sku.default) || product.sku?.[0]
      }

      return {
        ...product,
        selectedSku: selectedSku,
      }
    })

    this.transformedData = {
      bundleMandatoryProducts: transformedMandatoryProducts,
      bundleOptionalProducts: transformedOptionalProducts,
      normalSkuVariants: skuWithIsSelected,
      productId: identifier,
      bundleProductId: productId,
      isBundle: isBundle || this.props.isBundle,
    }
  }

  getNormalSkuSelectedInfo = () => {
    const selectedSku = this.transformedData.normalSkuVariants?.find(
      item => item.isSelected
    )
    const selectedIdentifier = selectedSku ? selectedSku.identifier : ''
    return {
      skuId: selectedIdentifier,
      variantName: selectedSku?.skuProperties?.variantLabel || '',
    }
  }

  renderMultiVariants = () => {
    const data = this.transformedData || {}

    const {
      isBundle = false,
      normalSkuVariants = [],
      bundleMandatoryProducts = [],
      bundleOptionalProducts = [],
      productId = '',
      bundleProductId = '',
    } = data

    if (!isBundle && normalSkuVariants?.length === 1) {
      return this.renderSingleSkuProductName(normalSkuVariants?.[0])
    }

    const variantTitle = isBundle
      ? i18nTranslate('Subscription.buildbundle', 'Build Your Bundle')
      : i18nTranslate('select.YourOption', 'Select your option')
    const optionalTitle = i18nTranslate(
      'Subscription.optionalPdtTitle',
      'Optional Products'
    )

    return (
      <div
        className="d-flex flex-column"
        data-testid="qa-multivariant-main-container">
        {this.props.actionType === 'add' && (
          <span
            className={`${
              isBundle
                ? 'subs-bundle-multivariant-title'
                : 'subs-single-product'
            } subs-multivariant-title`}
            data-testid="qa-multivariant-title">
            {variantTitle}
            {': '}
            <span
              className="variant-label-selected"
              data-testid="qa-multivariant-selected-label">
              {!isBundle && this.getNormalSkuSelectedInfo()?.variantName}
            </span>
          </span>
        )}
        {isBundle ? (
          <>
            {bundleMandatoryProducts?.map((product, idx) => (
              <div
                data-testid={`qa-mandatory-product-container-${product?.selectedSku?.identifier}`}
                key={product?.selectedSku?.identifier}
                className={
                  idx !== bundleMandatoryProducts?.length - 1
                    ? 'multivariant-bundle-component-mandatory'
                    : 'multivariant-bundle-component-mandatory-last'
                }>
                {this.renderBundleProductVariant(product, 'mandatory')}
              </div>
            ))}
            {bundleOptionalProducts?.length > 0 && (
              <>
                <div
                  className="bundle-optional-pdt-title"
                  data-testid="qa-optional-products-title">
                  {optionalTitle}
                </div>
                {bundleOptionalProducts?.map(product => (
                  <div
                    data-testid={`qa-optional-product-container-${product?.selectedSku?.identifier}`}>
                    {this.renderBundleProductVariant(product, 'optional')}
                  </div>
                ))}
              </>
            )}
          </>
        ) : (
          <div
            className="subs-multivariant-items"
            data-testid="qa-normal-sku-variants-container">
            {normalSkuVariants?.map(item =>
              this.renderVariantRadioOption({ item, type: 'normal', productId })
            )}
          </div>
        )}
      </div>
    )
  }

  renderSingleSkuProductName = (skuItem = {}) => {
    if (!skuItem) return null
    const name =
      skuItem?.properties?.name || skuItem?.skuProperties?.variantLabel || ''
    return (
      <span className="bundle-product-name" tabIndex={0}>
        {name}
      </span>
    )
  }

  renderVariantRadioOption = (options = {}) => {
    const {
      item = {},
      product = {},
      type = '',
      isOptionDisabled = false,
      productId = '',
      isToDisableOptions = '',
    } = options
    const { productOption = [], sku = [] } = product
    const variantData = productOption?.[0]?.values || []
    const { identifier = '', skuProperties = {}, isSelected = false } = item
    const { variantLabel = '' } = skuProperties
    let skuIdOnInitOrEdit = ''
    if (this.props.actionType === 'add') {
      if (type === 'normal' && isSelected) {
        skuIdOnInitOrEdit = identifier
      } else if (
        variantData?.length > 0 &&
        (type === 'mandatory' || type === 'optional')
      ) {
        skuIdOnInitOrEdit = product?.selectedSku?.identifier
      }
    } else if (this.props.actionType === 'edit') {
      if (type === 'mandatory') {
        skuIdOnInitOrEdit =
          sku.find(pdt => pdt.isSelectedForEdit)?.identifier || ''
      } else if (type === 'optional') {
        if (product.optionalProductAdded) {
          skuIdOnInitOrEdit =
            sku.find(pdt => pdt.isOptionalSkuSelected)?.identifier || ''
        }
        if (skuIdOnInitOrEdit === '') {
          skuIdOnInitOrEdit = sku.find(pdt => pdt.default)?.identifier || ''
        }
      }
    }
    const isDisabled = !!isToDisableOptions

    if (!variantLabel) {
      return <></>
    }

    return (
      <div
        className="subs-multivariant-item"
        data-testid={`qa-variant-radio-container-${identifier}`}
        aria-hidden={isDisabled ? 'true' : undefined}
        key={'variant-' + identifier}>
        <input
          type="radio"
          name={`multiVariantRadios-' + ${productId || product.identifier}`}
          id={'variant-' + identifier}
          onChange={() => this.handleVariantChange(item, product)}
          key={'radio' + variantLabel}
          checked={skuIdOnInitOrEdit === identifier || isSelected}
          className="sr-only"
          data-testid={`qa-variant-radio-${identifier}`}
          disabled={isDisabled}
        />
        <label htmlFor={'variant-' + identifier}>{variantLabel}</label>
      </div>
    )
  }

  handleVariantChange = (item = {}, product = {}) => {
    const { identifier = '', skuProperties = {} } = item
    const { variantLabel = '' } = skuProperties

    if (
      Array.isArray(product.sku) &&
      product.sku?.length > 0 &&
      product.identifier
    ) {
      if (product.type === 'mandatory') {
        product.sku = product.sku?.map(sku => ({
          ...sku,
          isSelectedForEdit: sku.identifier === identifier,
        }))
        this.transformedData?.bundleMandatoryProducts?.forEach(mandatoryPdt => {
          if (mandatoryPdt?.identifier === product.identifier) {
            mandatoryPdt.sku = product.sku
          }
        })
      } else if (product.type === 'optional') {
        product.sku = product.sku?.map(sku => ({
          ...sku,
          isOptionalSkuSelected: sku.identifier === identifier, //optional flag to be updated here
        }))
        this.transformedData?.bundleOptionalProducts?.forEach(optionalPdt => {
          if (optionalPdt?.identifier === product.identifier) {
            optionalPdt.sku = product.sku
          }
        })
      }
    }

    if (this.props.isBundle) {
      //Make current selected sku as selectedSku
      product.selectedSku = item
    } else {
      this.transformedData.normalSkuVariants?.forEach(variant => {
        if (variant.identifier === identifier) {
          variant.isSelected = true
        } else {
          variant.isSelected = false
        }
      })
    }
    //Make promotion api for pricing on swithing variants
    this.makePromotionAPI()
    this.props.updateSelectedVariant(this.transformedData)
  }

  addOrRemoveOptionalBundleItem = (optionalProduct = {}, option) => {
    const optionalProductId = optionalProduct?.identifier || ''
    const optionalProductSkuId = optionalProduct?.selectedSku?.identifier || ''
    // Update the optionalProductAdded flag
    this.transformedData.bundleOptionalProducts?.forEach(product => {
      if (product.identifier === optionalProductId) {
        product.optionalProductAdded = option === 'add' // Set flag based on action
      }
    })

    //Updating optionalData in productDeps to get the skus list for addtosubscription API
    if (option === 'add') {
      productDeps.optionalData?.push(optionalProductId)
    } else {
      productDeps.optionalData.splice(
        productDeps.optionalData.indexOf(optionalProductId),
        1
      )
    }
    this.makePromotionAPI()
    this.props.updateSelectedVariant(this.transformedData)
  }

  renderBundleProductVariant = (product = {}, type = '') => {
    const { properties = {}, productOption = [], sku = [] } = product
    const variantData =
      Array.isArray(productOption) && productOption.length > 0
        ? productOption?.[0]?.values
        : []

    const optionalIncludeCheckboxLabel = i18nTranslate(
      'Subscription.includeBundleTitle',
      'Include in bundle'
    )
    let productName = product?.selectedSku?.properties?.name || ''

    let alreadyAddedToBundle = false
    let isToDisableOptions = ''
    if (type === 'mandatory') {
      if (this.props.actionType === 'edit' && product.sku?.length > 1) {
        productName = product.sku?.find(
          skuElement => skuElement.isSelectedForEdit
        )?.properties?.name
      }
    } else if (type === 'optional') {
      alreadyAddedToBundle = this.transformedData.bundleOptionalProducts?.some(
        optionalProduct =>
          optionalProduct.identifier === product.identifier &&
          optionalProduct.optionalProductAdded
      )
      isToDisableOptions = !alreadyAddedToBundle ? 'disabled' : ''
      if (this.props.actionType === 'edit' && product.sku?.length > 1) {
        if (alreadyAddedToBundle) {
          // Show selected SKU name if added
          productName =
            product.sku?.find(skuElement => skuElement.isOptionalSkuSelected)
              ?.properties?.name ||
            product.sku?.find(skuElement => skuElement.default)?.properties
              ?.name ||
            ''
        } else {
          // Show default SKU name if not added
          productName =
            product.sku?.find(skuElement => skuElement.default)?.properties
              ?.name || ''
        }
      }
    }

    const optionsForRadioButtons = {
      product,
      isToDisableOptions,
      type,
    }

    return (
      <div className={`${'multivariant-bundle-wrapper-' + type}`}>
        <span className="bundle-product-name" tabIndex={0}>
          {productName}
        </span>
        {type === 'optional' && (
          <FormCheck className="d-block mt-3 optional-product-btn-checkbox">
            <FormCheck.Input
              checked={alreadyAddedToBundle}
              data-testid={`qa-add-optional-item-btn-${product?.selectedSku?.identifier}`}
              onChange={e =>
                this.addOrRemoveOptionalBundleItem(
                  product,
                  alreadyAddedToBundle ? 'remove' : 'add'
                )
              }
              type="checkbox"
              className="payment-agreement-checkbox"
              id={`optional_include_checkbox_${product?.selectedSku?.identifier}`}
            />
            <FormCheck.Label
              className="cursor-default optional-add-checkbox"
              data-testid="qa-add-optional-item-btn-label"
              htmlFor={`optional_include_checkbox_${product?.selectedSku?.identifier}`}>
              {optionalIncludeCheckboxLabel}
            </FormCheck.Label>
          </FormCheck>
        )}
        <div className={`variant-options-wrapper ${isToDisableOptions}`}>
          {variantData?.length === sku?.length && variantData?.length > 1 && (
            <div
              className="bundle-product-select-option"
              aria-hidden={isToDisableOptions ? 'true' : 'false'}>
              {i18nTranslate('select.YourOption', 'Select your option')}
              {': '}
            </div>
          )}

          <fieldset className="subs-multivariant-fieldset">
            {variantData?.length === sku?.length && sku?.length > 1 && (
              <div className="subs-multivariant-items">
                {sku?.map(item =>
                  this.renderVariantRadioOption({
                    ...optionsForRadioButtons,
                    item,
                  })
                )}
              </div>
            )}
          </fieldset>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="multi-variants-container">
        {this.renderMultiVariants()}
      </div>
    )
  }
}

export { SubscriptionMultiVariants }
export default SubscriptionMultiVariants
